<template>
	<section>
		<div v-if="isFormModal" class="overlay" @click="closeForm"></div>

		<div class="sidebar">
			<ul class="menu_list">
				<li class="menu_item" @click="selectTab('user')" :class="{'active': activeTab == 'user'}">Пользователи</li>
				<li class="menu_item" @click="selectTab('worker')" :class="{'active': activeTab == 'worker'}">Врачи</li>
				<li class="menu_item" @click="selectTab('clinic')" :class="{'active': activeTab == 'clinic'}">Клиники</li>
				<li class="menu_item" @click="selectTab('specialization')" :class="{'active': activeTab == 'specialization'}">
					Специализации
				</li>

				<li class="menu_item" @click="selectTab('role')" :class="{'active': activeTab == 'role'}">Роли</li>
			</ul>
		</div>
		<div class="main_container">
			<div class="filter_field">
				<input title="filter of list" type="text" v-model="filterField">
			</div>

			<div class="create">
				<button @click="addInstance" class="styled_button add_instance">Добавить</button>
			</div>

			<div class="table">
				<div class="table_row" v-for="(instance, index) in filteredList"
						 :class="{'even': index % 2 === 0}">

					<div class="name" v-if="activeTab == 'user'" @click="editInstance(instance, activeTab)">
						{{instance.first_name}} {{instance.last_name}}
					</div>
					<div class="name" v-if="activeTab == 'worker'" @click="editInstance(instance, activeTab)">
						{{instance.user_first_name}} {{instance.user_last_name}}
					</div>
					<div class="name" v-if="activeTab == 'clinic'" @click="editInstance(instance, activeTab)">
						{{instance.name}}
					</div>
					<div class="name" v-if="activeTab == 'specialization'" @click="editInstance(instance, activeTab)">
						{{instance.name}}
					</div>
					<div class="name" v-if="activeTab == 'role'" @click="editInstance(instance, activeTab)">
						{{instance.name}}
					</div>

					<button class="styled_button remove" @click="removeInstance(instance)">Удалить</button>

				</div>
			</div>

			<div class="formModal" v-if="isFormModal">
				<div class="form_body">
					<div class="header">{{activeTab}}</div>
					<div class="component" :is="instanceForm" :model="instanceData"></div>
					<div class="footer">
						<button class="styled_button" @click="updateInstance">Обновить</button>
						<button class="styled_button" @click="closeForm">Закрыть</button>
					</div>
				</div>
			</div>

			<div class="pagination">
				<button class="styled_button prev_page" @click="previousPage" :disabled="paginationData.current_page < 2">
					Назад
				</button>
				<div class="page_number">{{paginationData.current_page}} из {{paginationData.last_page}}</div>
				<button class="styled_button next_page" @click="nextPage"
								:disabled="paginationData.to  === paginationData.total">Вперед
				</button>
			</div>
		</div>
	</section>
</template>

<script>
	import UserForm from './forms/UserForm.vue'
	import WorkerForm from './forms/WorkerForm.vue'
	import ClinicForm from './forms/ClinicForm.vue'
	import SpecializationForm from './forms/SpecializationForm.vue'
	import RoleForm from './forms/RoleForm.vue'

	import moment from 'moment'

	const forms = {
		'user': 'UserForm',
		'worker': 'WorkerForm',
		'clinic': 'ClinicForm',
		'specialization': 'SpecializationForm',
		'role': 'RoleForm'
	}

	export default {
		name: "AdminPanel",
		components: {UserForm, WorkerForm, ClinicForm, SpecializationForm, RoleForm},
		computed: {
			filteredList() {
				return this.instancesList.filter(item => {
					let regexp = new RegExp(this.filterField, 'i')

					return regexp.test(item.name)
				})
			},
			isFormModal() {
				return !!Object.keys(this.instanceData).length
			}
		},
		mounted() {
			this.getList(this.activeTab)
		},
		data() {
			return {
				activeTab: 'user',
				filterField: '',
				instancesList: [],
				paginationData: {},
				instanceData: {},
				instanceForm: ''
			}
		},
		methods: {
			getList(instance, page = 1) {
				this.$store.dispatch(instance + '/list', {
					per_page: 15,
					current_page: page
				}).then(list => {
					this.instancesList = list.data

					this.paginationData = list
					this.addSearchField(this.instancesList)
				})
			},
			selectTab(tabName) {
				if (tabName !== this.activeTab) {
					this.getList(tabName)
				}

				this.activeTab = tabName
			},
			addInstance() {
				this.instanceForm = forms[this.activeTab]
				this.instanceData = {
					isNew: true,
					birthday: ''
				}
			},
			editInstance(instance, tabName) {
				this.instanceForm = forms[tabName]

				if (instance.birthday) {
					instance.birthday = moment(instance.birthday, 'X').format('DD-MM-YYYY')
				}

				this.instanceData = instance
			},
			updateInstance() {
				if (this.instanceData.birthday) {
					this.instanceData.birthday = moment(this.instanceData.birthday, 'DD-MM-YYYY').format('X')
				}

				this.$store.dispatch(this.activeTab + '/update', this.instanceData).then(() => {
					this.closeForm()
					setTimeout(() => {
						this.getList(this.activeTab)
					}, 500)
				})
			},
			removeInstance(instance) {
				this.$store.dispatch(this.activeTab + '/delete', instance._id).then(() => {
					setTimeout(() => {
						this.getList(this.activeTab)
					}, 500)
				})
			},
			closeForm() {
				if (this.instanceData.birthday) {
					this.instanceData.birthday = moment(this.instanceData.birthday, 'DD-MM-YYYY').format('X')
				}

				this.instanceForm = ''
				this.instanceData = {}
			},
			addSearchField(list) {
				list.map(item => {
						if (this.activeTab === 'user') {
							item.name = item.last_name + ' ' + item.first_name + ' ' + item.middle_name
						} else if (this.activeTab === 'worker') {
							item.name = item.user_last_name + ' ' + item.user_first_name + ' ' + item.user_middle_name
						}
					}
				)
			},
			previousPage() {
				let page = +this.paginationData.current_page - 1
				this.getList(this.activeTab, page)
			},
			nextPage() {
				let page = +this.paginationData.current_page + 1
				this.getList(this.activeTab, page)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.overlay {
		position: fixed;
		width: 100%;
		height: 100%;
		background: black;
		opacity: 0.3;
		z-index: 500;
	}

	.styled_button {
		outline: none;
		border: none;
		width: 80px;
		height: 30px;
		background: #4575bd;
		display: inline-block;
		cursor: pointer;

		&.remove {
			background: rgba(255, 111, 57, 0.34);

			&:hover {
				background: #e63f00;
			}
		}

		&.add_instance {
			margin: 3px;
			background: #35c940;

			&:hover {
				background: #30b23a;
			}
		}

		&:hover {
			background: #39609b;
		}
	}

	.sidebar {
		display: inline-block;
		position: fixed;
		width: 15%;
		left: 0;
		top: 60px;
		bottom: 0;
		box-shadow: 0 1px 1px #515151;

		.menu_list {

			.menu_item {
				transition: background 0.2s;
				height: 40px;
				line-height: 40px;
				padding-left: 20px;

				&:hover {
					background: #5da1ff;
					cursor: pointer;
				}

				&.active {
					background: #5da1ff;
				}
			}
		}
	}

	.main_container {
		margin-left: 15%;
		height: 100vh;

		.filter_field {
			height: 50px;
			line-height: 50px;
			background: #4575bd;
			box-shadow: inset 0 1px 1px #515151;

			input {
				border: none;
				width: 80%;
				box-shadow: inset 0 0 1px #666;
				margin-left: 10%;
				height: 30px;
				padding-left: 10px;
			}
		}

		.table {
			height: calc(100% - 50px - 55px);
			overflow: auto;

			.table_row {
				cursor: pointer;
				height: 40px;
				line-height: 40px;
				padding-left: 15px;
				background: #e6e6e6;

				.name {
					width: 85%;
				}

				.name, .styled_button {
					display: inline-block;
				}

				&.even {
					background: #bed3dd;
				}
			}
		}

		.formModal {

			.form_body {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				border: 1px solid grey;
				z-index: 510;

				.header {
					height: 50px;
					background: dodgerblue;
					padding-left: 15px;
					line-height: 50px;
				}

				.component {
					padding: 15px;
					height: 500px;
					overflow: scroll;
				}

				.footer {
					height: 35px;
					border-top: 1px solid grey;
					line-height: 35px;
					text-align: right;
					padding: 15px;
				}
			}
		}

		.pagination {
			background: white;
			position: fixed;
			bottom: 28px;
			width: 85%;
			height: 40px;
			border-top: 1px solid grey;
			padding-top: 10px;
			text-align: center;

			.prev_page, .next_page {
				&:disabled {
					background: #bed3dd;
				}
			}

			.page_number {
				display: inline-block;
				width: 50px;
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Admin panel.vue?71385f72